import { render, staticRenderFns } from "./Bigs.vue?vue&type=template&id=301a4c00&"
import script from "./Bigs.vue?vue&type=script&lang=js&"
export * from "./Bigs.vue?vue&type=script&lang=js&"
import style0 from "./Bigs.vue?vue&type=style&index=0&id=301a4c00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports